import Vue from 'vue';
import Http from '@/Http';
import { Enterprise } from '@/types/work/enterprise';
import products from '@/store/models/work/enterprise/products/products';
import categories from '@/store/models/work/enterprise/products/categories';
import measures from '@/store/models/work/enterprise/products/measures';
import outgoing from '@/store/models/work/enterprise/invoices/outgoing';
import providers from '@/store/models/work/enterprise/providers';
import customers from '@/store/models/work/enterprise/customers';
import positions from '@/store/models/work/enterprise/positions';
import cashRegisters from '@/store/models/work/enterprise/cashRegisters';

export const ENTERPRISES_REQUEST = 'work/enterprises/request';
export const ENTERPRISE_REQUEST = 'work/enterprises/enterprise';

export const GET_ENTERPRISES = 'work/enterprises/getEnterprises';
export const GET_ENTERPRISE = 'work/enterprises/getEnterprise';
export const GET_STATUS = 'work/enterprises/getStatus';

const state = {
  status: null,
  enterprises: [],
  enterprise: {},
  current_id: null
};

const getters = {
  getEnterprises: (state:any):Array<Enterprise> => state.enterprises,
  getEnterprise: (state:any):Enterprise => state.enterprise,
  getStatus: (state:any):null|boolean => state.status
};

const actions = {
  request: ({ commit, dispatch }:any) => {
    commit('request');
    (new Http()).request({ url: 'user/get-related-enterprises' })
      .then((res:any) => {
        commit('success', res.data.data);
      })
      .catch(() => {
        commit('error');
      });
  },
  enterprise: ({ commit, dispatch, state }:any, id:number) => {
    commit('request');
    commit('setEnterprise', { id: id });
    state.enterprises.forEach((enterprise:Enterprise) => {
      if (enterprise.enterprise_id === id) {
        commit('setEnterprise', {
          id: id,
          title: enterprise.enterprise_title
        });
      }
    });
    (new Http()).request({ url: `enterprise/${id}/get` })
      .then((res:any) => {
        commit('enterprise', res.data.data);
      })
      .catch(() => {
        commit('error');
      });
  }
};

const mutations = {
  request: (state:any) => {
    state.status = null;
  },
  success: (state:any, res:any) => {
    state.status = true;
    Vue.set(state, 'enterprises', res);
  },
  error: (state:any) => {
    state.status = false;
  },
  enterprise: (state:any, enterprise:Enterprise) => {
    state.status = true;
    Vue.set(state, 'enterprise', enterprise);
  },
  setEnterprise: (state:any, enterprise:Enterprise) => {
    Vue.set(state, 'enterprise', enterprise);
  }
};

export default {
  namespaced: true,
  modules: {
    products: products,
    categories: categories,
    measures: measures,
    providers: providers,
    positions: positions,
    customers: customers,
    cashRegisters: cashRegisters,
    invoices: {
      namespaced: true,
      modules: {
        outgoing: outgoing,
        income: outgoing
      }
    }
  },
  state,
  getters,
  actions,
  mutations
};
